import { useTranslation } from "react-i18next";
import Modal from "../../../modals/modal.component";
import { useEffect, useState } from "react";
import PasswordInput from "../../../password/password-input.component";
import { ErrorsType } from "../../../errors/errors.type";
import { ErrorsComponent } from "../../../errors/errors.component";
import apiClient from '../../../../helpers/apiClient';
import { UserType } from "../../../../types/user.type";

export interface EditProfilePasswordProperties {
  success: boolean;
  setSuccess: (success: boolean) => void;
  setScreen: (screen: string) => void;
  setLoading: (loading: boolean) => void;
  userInfo: UserType;
  setScene: (scene: string | undefined) => void;
}

export function EditProfilePasswordComponent(properties: EditProfilePasswordProperties): JSX.Element {
  const { t } = useTranslation();

  const [password, setPassword] = useState<string>('');

  const [repeatPassword, setRepeatPassword] = useState<string>('');

  const [submit, setSubmit] = useState<boolean>(false);

  const [errors, setErrors] = useState<ErrorsType | undefined>()

  const [passwordsNotMatch, setPasswordsNotMatch] = useState<boolean>(false);

  useEffect(() => {
    if (password && repeatPassword && password !== repeatPassword) {
      setErrors({
        passwordsNotMatch: [t('form.errors.passwords')]
      })
      setPasswordsNotMatch(true)
    } else {
      setErrors(undefined)
      setPasswordsNotMatch(false)
    }
  }, [password, repeatPassword]);

  const onSubmit = () => {
    if (properties.userInfo.is_generic) return;

    if (passwordsNotMatch) return;

    const errors: { password?: string[], repeatPassword?: string[] } = {};

    if (!password || password.trim() === '') {
      errors.password = [t('edit.profile.form.required')];
    }

    if (!repeatPassword || repeatPassword.trim() === '') {
      errors.repeatPassword = [t('edit.profile.form.required')];
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setSubmit(true);

    properties.setLoading(true);

    setErrors({});

    apiClient.put(`/api/user/edit-password/${properties.userInfo.id}`, {
      password: password,
    }).then((response) => {
      setTimeout(() => {
        properties.setSuccess(true);
        properties.setLoading(false);
        setSubmit(false);
      }, 1000);
    }).catch((error) => {
      setTimeout(() => {
        properties.setLoading(false);

        const errors = error?.response?.data?.errors;

        if (errors) {
          setErrors(errors)
        } else {
          setErrors({ general: ['Error de conexión'] })
        }
      }, 1000);
    });
  }

  return <>
      <ErrorsComponent errors={errors} name="general" />
      <div
        className='Form'
        style={{
            paddingTop: 10,
        }}
      >
      {
        properties.success && <Modal
          isOpen={true}
          type='success'
          onClose={() => {
            properties.setSuccess(false)
            properties.setScene(undefined)
          }}
          body={{
            title: t('edit.profile.password'),
            content: t('edit.profile.success')
          }}
        >

        </Modal>
        }
      <p>{t('restore.password')}</p>
      <PasswordInput
        name="password"
        providers={[ { name: 'local' } ]}
        placeholder={t('restore.password')}
        setPassword={setPassword}
        checkPassword={true}
        submitAttempt={submit}
        disabled={!!properties.userInfo.is_generic}
        />
      <ErrorsComponent errors={errors} name="password" />
      <p>{t('restore.repeatPassword')}</p>
      <PasswordInput
        name="repeatPassword"
        providers={[ { name: 'local' } ]}
        placeholder={t('restore.repeatPassword')}
        setPassword={setRepeatPassword}
        disabled={!!properties.userInfo.is_generic}
        />
      <ErrorsComponent errors={errors} name="repeatPassword" />
      <ErrorsComponent errors={errors} name="passwordsNotMatch" />
      {properties.userInfo.is_generic && (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 12, padding: '10px 12px', backgroundColor: '#f0f4ff', borderRadius: 6, color: '#4a5568', fontSize: 13 }}>
          <i className="las la-info-circle" style={{ fontSize: 18, marginTop: 1, color: '#3182ce', flexShrink: 0 }}></i>
          <span>{t('edit.profile.generic_user_info')}</span>
        </div>
      )}
      <div className='Space' />
      <div className={`Submit${properties.userInfo.is_generic ? ' disabled' : ''}`} onClick={onSubmit} style={properties.userInfo.is_generic ? { opacity: 0.5, pointerEvents: 'none' } : {}}>
        {t('form.update.title')}
      </div>
    </div>
  </>
}
